"use client";

import { useState } from "react";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_leagues_favorite.svg";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_leagues_favorite.svg";
import { Image } from '@/lib/target';

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

const CollapsiblePanel = ({
  children,
  title,
  className = "",
  initOpen = false,
  iconUp = IMAGE_ARROW_UP_LEAGUES,
  iconDown = IMAGE_ARROW_DOWN_LEAGUES,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initOpen);

  const handleCollapseLeague = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div className={`mt-8 ${className}`}>
      <div className="flex flex-wrap items-center bg-button-blue-bet dark:bg-black gap-2 px-3 py-1" onClick={() => handleCollapseLeague()}>
        <Image
          alt="Net88"
          src={isCollapsed ? iconDown : iconUp}
          width={12}
          height={12}
          className="block hover:cursor-pointer"
        />

        <div className="bg-button-blue-bet dark:bg-black text-white-half dark:text-white-half font-semibold rounded text-sm">
            {title}
        </div>

      </div>
      
      <div
        id="collapse"
        className={`${
          isCollapsed ? "visible" : "hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsiblePanel;
